import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAllProducts } from "../api";
import Spinner from "../components/Spinner";
import { removeTemplate, serverURL } from "../product";
import "../styles/detailpage.css";
import styles from "../styles/productDetail.module.scss";
import { StoreProvider } from "./ContextProvider";

const ProductDetail = ({ product }) => {
  const { setAllProduct, token } = useContext(StoreProvider);
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const handleDelete = async (id) => {
    const confirm = window.confirm("Are sure delete this product");
    if (confirm) {
      setIsDeleting(true);
      const deleted = await removeTemplate(id, token);
      setIsDeleting(false);
      if (!deleted?.isError) {
        const newProducts = await getAllProducts(token);
        setAllProduct(newProducts?.products);
        navigate("/");
      }
    }
  };
  return (
    <div className={styles.productDetail}>
      <div className={styles?.wrapper}>
        <div>
          <div className="card mb-3 mt-3">
            {product?.image && (
              <img
                className={styles?.coverImg}
                src={`${serverURL}/image/${product?.image}`}
                alt=""
                loading="lazy"
              />
            )}
            <div className="d-flex justify-content-around p-4">
              <Link
                className="ms-5"
                title="detail"
                to={`/edit/${product?.product_id}`}
              >
                <button className="btn btn-warning ps-4 pe-4">Edit</button>
              </Link>
              <button
                disabled={isDeleting ? true : false}
                onClick={() => handleDelete(product?.product_id)}
                className="btn btn-danger ms-5"
              >
                Delete {isDeleting && <Spinner />}
              </button>
            </div>
            <div className="card-body pt-0 p-4">
              <h2 className="mb-3 card-title">{product?.name}</h2>
              <div className=" mb-5">
                <p>Slug: {product?.slug}</p>
                <p>Is Featured: {product?.is_featured ? "Yes" : "No"}</p>
                <p>
                  Tags:{" "}
                  {product?.tags?.length > 0 &&
                    product?.tags?.map((tag) => (
                      <span
                        className="p-1 me-2 rounded text-light bg-info"
                        key={tag?.id}
                      >
                        {tag?.name}
                      </span>
                    ))}
                </p>
                <p>Built with: {product?.built_with}</p>
                <p>Version: {product?.current_version}</p>

                <p>
                  Created:{" "}
                  {new Date(product?.created_at).toLocaleDateString("en-GB")}
                </p>
                <p>
                  Last Update:{" "}
                  {new Date(product?.updated_at).toLocaleDateString("en-GB")}
                </p>
                <p>
                  Preview Link:{" "}
                  <a
                    href={product?.preview_link}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {product?.preview_link}
                  </a>
                </p>
                <p>Total sales: {product?.sales}</p>
                <p>Total earnings: ${product?.earnings}</p>
                <p>Total Free Download: {product?.free_download}</p>
                <p>Default Variation : {product?.default_variation}</p>
                <h5>Price</h5>
                {product?.price?.starter > 0 && (
                  <p>Starter: ${product?.price?.starter}</p>
                )}
                {product?.price?.business > 0 && (
                  <p>Business: ${product?.price?.business}</p>
                )}
                {product?.price?.extend > 0 && (
                  <p>Extend: ${product?.price?.extend}</p>
                )}
                <h5>Download File</h5>
                {product?.download_file?.free.length > 0 && (
                  <p>Free: {product?.download_file?.free}</p>
                )}
                {product?.download_file?.starter.length > 0 && (
                  <p>Starter: {product?.download_file?.starter}</p>
                )}
                {product?.download_file?.business.length > 0 && (
                  <p>Business: {product?.download_file?.business}</p>
                )}
                {product?.download_file?.extended.length > 0 && (
                  <p>Extended: {product?.download_file?.extended}</p>
                )}
                <h5>License File</h5>
                {product?.download_file_license?.free.length > 0 && (
                  <p>Free: {product?.download_file_license?.free}</p>
                )}
                {product?.download_file_license?.starter.length > 0 && (
                  <p>Starter: {product?.download_file_license?.starter}</p>
                )}
                {product?.download_file_license?.business.length > 0 && (
                  <p>Business: {product?.download_file_license?.business}</p>
                )}
                {product?.download_file_license?.extended.length > 0 && (
                  <p>Extended: {product?.download_file_license?.extended}</p>
                )}
              </div>
              <h4>Product Detail</h4>
              <div
                className="w-100 detail_body"
                dangerouslySetInnerHTML={{ __html: product?.detail }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
